import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-100 w-sm-90 w-xs-90 mt-10 mt-lg-15 mx-lg-auto mx-sm-auto mx-xs-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, " Cancel Checkout "))
}